import { NavLink, Link } from 'react-router-dom'
import { useWallet } from '../contexts/WalletContext'

function shortenAddress(addr: string): string {
  return `${addr.slice(0, 6)}···${addr.slice(-4)}`
}

// Shield-check icon (inline SVG)
function ShieldIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <polyline points="9 12 11 14 15 10" />
    </svg>
  )
}

function GridIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
    </svg>
  )
}

function UserIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
    </svg>
  )
}

function AdminIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M19.07 4.93A10 10 0 0 0 4.93 4.93M4.93 19.07A10 10 0 0 0 19.07 19.07" />
      <path d="M12 2v2m0 18v2M2 12h2m18 0h2" />
    </svg>
  )
}

const ADMIN_ADDRESS = (import.meta.env.VITE_ADMIN_ADDRESS as string | undefined)?.toLowerCase()

export default function Header() {
  const { address, isConnected, openConnectModal, disconnect } = useWallet()
  const isAdmin = isConnected && address && ADMIN_ADDRESS && address.toLowerCase() === ADMIN_ADDRESS

  return (
    <header className="hdr">
      <div className="shell">
        <div className="hdr-in">
          {/* Brand */}
          <Link to="/" className="brand">
            <div className="brand-mark">
              <ShieldIcon />
            </div>
            <span className="brand-name">
              온체인<b>챌린지</b>
            </span>
          </Link>

          {/* Nav */}
          <nav className="hdr-nav">
            <NavLink
              to="/"
              end
              className={({ isActive }) => `hdr-link${isActive ? ' active' : ''}`}
            >
              <GridIcon /> 탐색
            </NavLink>
            {isConnected && (
              <NavLink
                to="/my"
                className={({ isActive }) => `hdr-link${isActive ? ' active' : ''}`}
              >
                <UserIcon /> 마이페이지
              </NavLink>
            )}
            {isAdmin && (
              <NavLink
                to="/admin"
                className={({ isActive }) => `hdr-link${isActive ? ' active' : ''}`}
              >
                <AdminIcon /> 관리자
              </NavLink>
            )}
          </nav>

          <div className="hdr-spacer" />

          {/* Wallet */}
          {isConnected && address ? (
            <div className="wallet-chip">
              <span className="wallet-net">
                <span className="net-dot" />
                Sepolia
              </span>
              <span className="wallet-divider" />
              <span className="wallet-addr">{shortenAddress(address)}</span>
              <button
                className="wallet-logout"
                onClick={disconnect}
                aria-label="연결 해제"
                title="연결 해제"
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="6" y1="6" x2="18" y2="18" />
                  <line x1="18" y1="6" x2="6" y2="18" />
                </svg>
              </button>
            </div>
          ) : (
            <button className="btn btn-primary btn-sm" onClick={openConnectModal}>
              지갑 연결
            </button>
          )}
        </div>
      </div>
    </header>
  )
}
